import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { TaskItem, Task } from './TaskItem';
interface TaskListProps {
  tasks: Task[];
  onToggle: (id: string) => void;
}
export function TaskList({
  tasks,
  onToggle
}: TaskListProps) {
  return <div className="space-y-1" data-id="element-535">
      <AnimatePresence mode="popLayout" data-id="element-536">
        {tasks.map(task => <TaskItem key={task.id} task={task} onToggle={onToggle} data-id="element-537" />)}
      </AnimatePresence>

      {tasks.length === 0 && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} className="text-center py-12" data-id="element-538">
          <p className="font-quicksand text-gray-400 font-medium" data-id="element-539">
            No tasks yet! Time to play! 🎮
          </p>
        </motion.div>}
    </div>;
}